import { render } from "./CGridColumn.vue?vue&type=template&id=6b132906&scoped=true"
import script from "./CGridColumn.vue?vue&type=script&lang=js"
export * from "./CGridColumn.vue?vue&type=script&lang=js"

import "./CGridColumn.vue?vue&type=style&index=0&id=6b132906&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b132906"]])

export default __exports__